module.exports = "/images/right-arrow.svg?7ee1ca2fd279a4fc1358dca78b1a43e3";